import { GET_ORGANISATION, setDefaultHeader } from '@/studbook/graphql/queries';
import { GetOrganisationResponse } from '@/studbook/graphql/results';
import { useQuery } from '@apollo/client';

export default function useOrgNameFromOrgId(orgId: string) {
  const {
    data: orgResponse,
    error: errorOrg,
    loading: loadingOrg,
  } = useQuery<GetOrganisationResponse>(GET_ORGANISATION, {
    skip: !orgId,
    variables: {
      orgId: Number(orgId),
    },
    context: {
      headers: {
        ...setDefaultHeader(orgId),
      },
    },
  });

  const orgName = orgResponse?.organisation.name;

  return orgName || '';
}
